module.exports = __webpack_public_path__ + "icomoon.woff?3c04f3ea24a931b85b0d67765497e1b1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon/icomoon.woff?-rdnm34
// module id = 920
// module chunks = 27